import { environment } from '@/app/environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NgHttpService } from '../auth/httpservice';
import { HttpClient } from '@angular/common/http';


@Injectable({
    providedIn: 'root'
})
export class UsuarioService {
    constructor(private http: HttpClient, private _http: NgHttpService) { }

    adicionar(data: any): Observable<any> {
        return this._http.post(environment.apiGeral, `Usuario/Adicionar`, data)
    }

    alterar(data: any): Observable<any> {
        return this._http.put(environment.apiGeral, `Usuario/Alterar`, data)
    }

    excluir(id: string): Observable<any> {
        return this._http.put(environment.apiGeral, `Usuario/Excluir/${id}`, {});
    }

    listarUsuarios(params: any): Observable<any> {
        return this._http.post(environment.apiGeral, `Usuario/ListarUsuarios`, params)
    }

    listar(params: any = { ativo: 0 }): Observable<any> {
        return this._http.get(environment.apiGeral, `Usuario`, params)
    }

    listarPorId(params: any): Observable<any> {
        return this._http.get(environment.apiGeral, `Usuario/ListarPorId`, params)
    }

    trocarSenha(params: any): Observable<any> {
        return this._http.post(environment.apiGeral, `Usuario/TrocarSenha`, params)
    }

    trocarFoto(params: any): Observable<any> {
        return this._http.put(environment.apiGeral, `Usuario/TrocarFoto`, params)
    }

    novaSenha(id: any): Observable<any> {
        return this._http.get(environment.apiGeral, `Usuario/GerarSenha`, id)
    }

    lembrarSenha(params: any): Observable<any> {
        return this._http.post(environment.apiAcessoExterno, `AcessoExterno/LembrarSenhaAcessoExterno`, params)
    }

    validarToken(params: any): Observable<any> {
        return this._http.get(environment.apiAcessoExterno, `AcessoExterno/ValidarTokenAcessoExterno`, params)
    }

    resetarSenha(params: any): Observable<any> {
        return this._http.post(environment.apiAcessoExterno, `AcessoExterno/ResetarSenhaAcessoExterno`, params)
    }
}
